import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";

export const showErrorAlert = <T>({ title, icon, text, ...options }: SweetAlertOptions): Promise<SweetAlertResult<T>> => {
    return showAlert({
        title: title || "Oops!!!",
        icon: icon || "error",
        text: text || "Something went wrong.",
        ...options
    })
}

export const showSuccessAlert = <T>({ title, icon, text, ...options }: SweetAlertOptions): Promise<SweetAlertResult<T>> => {
    return showAlert({
        title: title || "Success",
        text: text || "Success",
        icon: icon || "success",
        ...options
    })
}

export const showAlert = async <T>(options: SweetAlertOptions): Promise<SweetAlertResult<T>> => {
    const result = await Swal.fire(options)
    return result
}